export  const TOAST_CONFIG = {
        POSITION: 'toast-top-right',
        TIMEOUT_MS: 3000,
        EXTENDED_TIMEOUT_MS: 2000
    } as const;